(function () {
  'use strict';

  var TZ = 'Europe/Zurich';
  var DAY_SHORT = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var DAY_LONG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var DAY_MS = 86400000;

  var zurichFormatter = null;
  try {
    zurichFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23'
    });
  } catch (e) {
    zurichFormatter = null;
  }

  /* Aktuelles Datum + Sekunden seit Mitternacht in Zürcher Zeit */
  function zurichNow() {
    var now = new Date();
    if (!zurichFormatter) {
      return {
        y: now.getFullYear(), m: now.getMonth() + 1, d: now.getDate(),
        sec: now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds()
      };
    }
    var p = {};
    zurichFormatter.formatToParts(now).forEach(function (part) { p[part.type] = part.value; });
    var h = parseInt(p.hour, 10);
    if (h === 24) h = 0;
    return {
      y: +p.year, m: +p.month, d: +p.day,
      sec: h * 3600 + (+p.minute) * 60 + (+p.second)
    };
  }

  /* Kalenderdaten als UTC-Mitternacht, damit Sommer-/Winterzeit keine Rolle spielt */
  function makeDate(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function addDays(date, n) { return new Date(date.getTime() + n * DAY_MS); }
  function diffDays(a, b) { return Math.round((a.getTime() - b.getTime()) / DAY_MS); }

  /* Feiertage: 2026-12-25 | 25.12.2026 | 25.12. (jährlich) — getrennt durch Zeilenumbruch, Komma oder Semikolon */
  function parseHolidays(str) {
    var fixed = {};
    var recurring = {};
    (str || '').split(/[\n,;]+/).forEach(function (raw) {
      var s = raw.trim();
      var m;
      if (!s) return;
      if ((m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/))) {
        fixed[+m[1] + '-' + (+m[2]) + '-' + (+m[3])] = true;
      } else if ((m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/))) {
        fixed[+m[3] + '-' + (+m[2]) + '-' + (+m[1])] = true;
      } else if ((m = s.match(/^(\d{1,2})\.(\d{1,2})\.?$/))) {
        recurring[(+m[2]) + '-' + (+m[1])] = true;
      }
    });
    return function (date) {
      var y = date.getUTCFullYear();
      var mo = date.getUTCMonth() + 1;
      var d = date.getUTCDate();
      return !!(fixed[y + '-' + mo + '-' + d] || recurring[mo + '-' + d]);
    };
  }

  function fmtDate(date) {
    return DAY_SHORT[date.getUTCDay()] + ' ' + date.getUTCDate() + '.' + (date.getUTCMonth() + 1) + '.';
  }

  function fmtRelativeDate(date, today) {
    var n = diffDays(date, today);
    if (n === 0) return 'heute, ' + fmtDate(date);
    if (n === 1) return 'morgen, ' + fmtDate(date);
    return 'am ' + fmtDate(date);
  }

  function fmtRelativeShip(date, today) {
    var n = diffDays(date, today);
    if (n === 0) return 'heute';
    if (n === 1) return 'morgen';
    return 'am ' + DAY_LONG[date.getUTCDay()];
  }

  function fmtCountdown(seconds) {
    var mins = Math.max(1, Math.ceil(seconds / 60));
    var h = Math.floor(mins / 60);
    var m = mins % 60;
    if (h === 0) return m + ' Min.';
    if (m === 0) return h + ' Std.';
    return h + ' Std. ' + m + ' Min.';
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Platzhalter ersetzen: [lieferdatum], [lieferdatum_relativ], [versanddatum], [versanddatum_relativ], [versandtag], [countdown], [bestellschluss] */
  function fillTemplate(tpl, vars) {
    return esc(tpl || '').replace(/\[(\w+)\]/g, function (match, key) {
      if (!Object.prototype.hasOwnProperty.call(vars, key)) return match;
      var value = esc(vars[key]);
      if (key === 'countdown') return '<span class="zs__countdown notranslate">' + value + '</span>';
      return value;
    });
  }

  function initModule(el) {
    if (el.__zsInit) return;
    el.__zsInit = true;

    var ds = el.dataset;
    var cutoffHour = parseInt(ds.cutoffHour || '13', 10);
    var cutoffMinute = parseInt(ds.cutoffMinute || '0', 10);
    var cutoffSec = cutoffHour * 3600 + cutoffMinute * 60;
    var deliveryDays = Math.max(0, parseInt(ds.deliveryDays || '1', 10));
    var deliverSaturday = ds.deliverySaturday === 'true';
    var isHoliday = parseHolidays(ds.holidays);
    var labelToday = ds.labelToday || 'Heute';

    var titleEl = el.querySelector('[data-zs-title]');
    var textEl = el.querySelector('[data-zs-text]');
    var dateOrdered = el.querySelector('[data-zs-date="ordered"]');
    var dateShipped = el.querySelector('[data-zs-date="shipped"]');
    var dateDelivered = el.querySelector('[data-zs-date="delivered"]');

    function isShipDay(d) {
      var w = d.getUTCDay();
      return w >= 1 && w <= 5 && !isHoliday(d);
    }

    function isDeliveryDay(d) {
      var w = d.getUTCDay();
      var workday = (w >= 1 && w <= 5) || (deliverSaturday && w === 6);
      return workday && !isHoliday(d);
    }

    function render() {
      var z = zurichNow();
      var today = makeDate(z.y, z.m, z.d);
      var beforeCutoff = isShipDay(today) && z.sec < cutoffSec;

      var shipDate = today;
      if (!beforeCutoff) {
        shipDate = addDays(today, 1);
        for (var i = 0; i < 60 && !isShipDay(shipDate); i++) shipDate = addDays(shipDate, 1);
      }

      var deliveryDate = shipDate;
      var counted = 0;
      for (var j = 0; j < 60 && counted < deliveryDays; j++) {
        deliveryDate = addDays(deliveryDate, 1);
        if (isDeliveryDay(deliveryDate)) counted++;
      }

      var state = beforeCutoff ? 'before' : (diffDays(shipDate, today) === 1 ? 'after' : 'weekend');
      var key = state.charAt(0).toUpperCase() + state.slice(1);

      var vars = {
        lieferdatum: fmtDate(deliveryDate),
        lieferdatum_relativ: fmtRelativeDate(deliveryDate, today),
        versanddatum: fmtDate(shipDate),
        versanddatum_relativ: fmtRelativeShip(shipDate, today),
        versandtag: DAY_LONG[shipDate.getUTCDay()],
        countdown: beforeCutoff ? fmtCountdown(cutoffSec - z.sec) : '',
        bestellschluss: pad(cutoffHour) + ':' + pad(cutoffMinute)
      };

      if (titleEl) titleEl.innerHTML = fillTemplate(ds['title' + key], vars);
      if (textEl) textEl.innerHTML = fillTemplate(ds['text' + key], vars);

      if (dateOrdered) dateOrdered.textContent = labelToday;
      if (dateShipped) dateShipped.textContent = diffDays(shipDate, today) === 0 ? labelToday : fmtDate(shipDate);
      if (dateDelivered) dateDelivered.textContent = fmtDate(deliveryDate);

      el.setAttribute('data-state', state);
      el.classList.add('is-ready');
    }

    render();
    el.__zsTimer = setInterval(render, 15000);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) render();
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-zustellung]').forEach(initModule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme-Editor */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target.parentNode || document); });
})();
